export default __webpack_public_path__ + "static/media/bubble.c4134965.png";